import Input from './Input';
import Group from './Group';
import Search from './Search';
import TextArea from './TextArea';
import Password from './Password';
import OTP from './OTP';
Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;
Input.OTP = OTP;
/* istanbul ignore next */
Input.install = function (app) {
    app.component(Input.name, Input);
    app.component(Input.Group.name, Input.Group);
    app.component(Input.Search.name, Input.Search);
    app.component(Input.TextArea.name, Input.TextArea);
    app.component(Input.Password.name, Input.Password);
    app.component(Input.OTP.name, Input.OTP);
    return app;
};
export { Group as InputGroup, Search as InputSearch, TextArea as Textarea, Password as InputPassword, OTP as InputOTP, };
export default Input;
